import { useCallback } from 'react'

export default ({ onChange, field: variationField, selectIngredient }) => {

  const handleChangeOrder = useCallback(({ category, categoryIndex, items, oldIndex, newIndex }) => {
    const target = `values[${variationField}].sections[${categoryIndex}].ingredients`
    onChange({
      target: {
        value: items,
        name: target,
      },
    }, (model, modifyUtils) => modifyUtils.swapErrors(
      model,
      `values[${variationField}].sections[${categoryIndex}].ingredients[${oldIndex}]`,
      `values[${variationField}].sections[${categoryIndex}].ingredients[${newIndex}]`,
    ))
    selectIngredient(`sections[${categoryIndex}].ingredients[${newIndex}]`)
  }, [onChange, selectIngredient, variationField])
  return handleChangeOrder
}
